var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoSmoking = function SvgNoSmoking(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M7.6 10.6v4m0-4h3m-3 0h-6a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h6m0 0h7M.6.6l10 10m0 0 4 4m0 0 4 4m-2.34-8h1.34v1.338m3 2.662v-4m0-4v-.5a2.5 2.5 0 0 0-2.5-2.5 2.5 2.5 0 0 1-2.5-2.5V.6"
  })));
};
export default SvgNoSmoking;